// Mega menu highlights bar: scrolls left to right at the announcement marquee's pace
if (!customElements.get('mega-highlights-marquee')) {
  class MegaHighlightsMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.group = this.querySelector('[data-group]');
      if (!this.track || !this.group) return;

      this.originalHTML = this.group.innerHTML;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onResize = this.debounce(() => this.build(), 150);
      this.details = this.closest('details');
      this.onToggle = () => {
        if (this.details.open) this.build();
      };

      this.build();
      window.addEventListener('resize', this.onResize);
      if (this.details) this.details.addEventListener('toggle', this.onToggle);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.details) this.details.removeEventListener('toggle', this.onToggle);
    }

    build() {
      this.track.classList.remove('is-ready');
      this.track.querySelectorAll('[data-clone]').forEach((el) => el.remove());
      this.group.innerHTML = this.originalHTML;
      if (this.reducedMotion.matches) return;

      const width = this.clientWidth;
      if (!width) return;

      // Repeat the items until one group spans the bar, then clone it so -50% loops cleanly
      const items = Array.from(this.group.children);
      let guard = 0;
      while (this.group.scrollWidth < width && items.length && guard < 20) {
        items.forEach((item) => this.group.appendChild(item.cloneNode(true)));
        guard += 1;
      }

      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      this.track.appendChild(clone);

      this.style.setProperty('--mega-highlights-duration', `${this.group.offsetWidth / this.pixelsPerSecond()}s`);
      requestAnimationFrame(() => this.track.classList.add('is-ready'));
    }

    // Match the announcement marquee: one of its groups crosses in --announcement-marquee-speed seconds
    pixelsPerSecond() {
      const bar = document.querySelector('.announcement-marquee');
      const group = bar && bar.querySelector('.announcement-marquee__group');
      const seconds = bar && parseFloat(getComputedStyle(bar).getPropertyValue('--announcement-marquee-speed'));
      if (group && group.offsetWidth && seconds) return group.offsetWidth / seconds;
      return 40;
    }

    debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('mega-highlights-marquee', MegaHighlightsMarquee);
}
